export default "__VITE_ASSET__DYWE0Yel__"